import { render, staticRenderFns } from "./Dbutton.vue?vue&type=template&id=2150b07a&scoped=true"
import script from "./Dbutton.vue?vue&type=script&lang=js"
export * from "./Dbutton.vue?vue&type=script&lang=js"
import style0 from "./Dbutton.vue?vue&type=style&index=0&id=2150b07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2150b07a",
  null
  
)

export default component.exports